import { render } from "./AtelierForm.vue?vue&type=template&id=23687dfa"
import script from "./AtelierForm.vue?vue&type=script&lang=js"
export * from "./AtelierForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__